export default "__VITE_ASSET__Ul4iHP7D__"